// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"f09c7d68","21":"c8f97f96","593":"96d4806f"}[chunkId] + ".css";
};